<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>#</th>
            <th>Link</th>
            <th>Url</th>
            <th>Anchor</th>
            <th>Pbn</th>
            <th>Client</th>
            <th>Placed</th>
            <th>Placer</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(placement, i) in placements" :key="placement.id">
            <td>{{ i + 1 }}</td>
            <td>{{ placement.link }}</td>
            <td><a :href="placement.url" target="_blank">{{ placement.url }} <i class="fa fa-external-link"></i></a></td>
            <td>{{ placement.anchor || '?' }}</td>
            <td><a :href="'/pbn/' + placement.pbn.punyDomain">{{ placement.pbn.domain }}</a></td>
            <td>{{ placement.pbn.client.name }}</td>
            <td>{{ $moment(placement.placed.date).format('DD.MM.Y') }}</td>
            <td>{{ placement.placer ? placement.placer.name : '?' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      placements: []
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      order: 'getLinkOrder'
    })
  },
  methods: {
    getPlacements () {
      axios.get('pbn/links/order/' + this.$route.params.id + '/placements')
        .then(r => {
          this.placements = r.data.data
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Role/Tabs/UserLog.vue